import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { collection, getDocs, query, Timestamp, where } from "firebase/firestore";
import { db } from "../../firebase";
import {Preloader} from "../../atoms/Preloader";

const ExportHistory = () => {
    const [searchParams] = useSearchParams();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const accountId = searchParams.get("id");
    const fromString = searchParams.get("from");
    const toString = searchParams.get("to");
    const fetchFilteredData = async (accountId, from, to) => {
        try {
            const paymentsRef = collection(db, "payments");
            const q = query(
                paymentsRef,
                where("connected_account_id", "==", accountId),
                where("datetime", ">=", from),
                where("datetime", "<=", to)
            );
            const querySnapshot = await getDocs(q);
            const filteredData = [];
            querySnapshot.forEach((doc) => {
                filteredData.push({ id: doc.id, ...doc.data() });
            });
            return filteredData;
        } catch (error) {
            console.error("Error fetching data:", error);
            throw error;
        }
    };

    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const seconds = String(date.getSeconds()).padStart(2, "0");

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };

    const convertToCSV = (data) => {
        if (data.length === 0) return "";
        const headers = [
            "Date",
            "Name",
            "Tips Amount",
            "Stripe fee",
            "Tipon fee",
            "Received amount",
            "Rating",
            "Review",
            "Question 1",
            "Answer 1",
            "Question 2",
            "Answer 2",
            "Question 3",
            "Answer 3",
        ];
        const ratingMap = { 0: "Bad", 1: "Good", 2: "Amazing" };
        const answerMap = { 1: "Bad", 2: "Good", 3: "Amazing", 5: "", null: "" };
        const rows = data.map((item) => {
            return [
                `"${formatDate(item.datetime.toDate())}"`,
                `"${item.name || ""}"`,
                `"$ ${(item.amount / 100).toFixed(2) || 0}"`,
                `"$ ${item.commissionChecked ? 0 : (item?.stripeFee / 100).toFixed(2) }"`,
                `"$ ${item.commissionChecked ? 0 : (item?.tiponFee / 100).toFixed(2) }"`,
                `"$ ${item.commissionChecked ? (item.amount / 100).toFixed(2) : ((Number(item.amount) - Number(item?.tiponFee) - Number(item?.stripeFee))  / 100).toFixed(2)}"`,
                `"${ratingMap[item.rating]}"`,
                `"${item.review || ""}"`,
                `"${item?.questions?.[0] || ""}"`,
                `"${answerMap[item?.answers?.[0]]}"`,
                `"${item?.questions?.[1] || ""}"`,
                `"${answerMap[item?.answers?.[1]]}"`,
                `"${item?.questions?.[2]  || ""}"`,
                `"${answerMap[item?.answers?.[2]]}"`,
            ];
        });

        return [headers.join(","), ...rows.map((row) => row.join(","))].join("\n");
    };


    const downloadCSV = () => {
        const csvData = convertToCSV(data);
        const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = `export_payments_${new Date().toISOString().slice(0, 19).replace(/:/g, "-")}.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        URL.revokeObjectURL(url);
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                if (accountId && fromString && toString) {
                    const parseDateToTimestamp = (dateString) => {
                        const date = new Date(dateString.replace(" ", "T"));
                        return Timestamp.fromDate(date);
                    };

                    const from = parseDateToTimestamp(fromString);
                    const to = parseDateToTimestamp(toString);

                    const result = await fetchFilteredData(accountId, from, to);
                    setData(result);
                }
            } catch (err) {
                setError("Failed to fetch data");
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [accountId, fromString, toString]);
    useEffect(() => {
        !loading && downloadCSV()
    }, [loading]);
    console.log(data, 'data')

    if (loading) return <Preloader/>
    if (error) return <div>Error: {error}</div>;

    return (
        <div>
            {/*<h1>Exported Data</h1>*/}
            {/*<button onClick={downloadCSV} style={{ marginBottom: 20 }}>Download CSV</button>*/}
        </div>
    );
};

export default ExportHistory;
